/* eslint-disable @nx/enforce-module-boundaries */
import { Card, HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { SavedJobCard } from 'v4/components/jobs/saved-job-card';
import { JobsNotFoundIllustration } from '../404';
import { JobsListingContext } from '../context';
import { useRouter } from 'next/router';
import { SavedJobsNotFoundIll } from '../404/saved-jobs';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const SavedJobsListing = forwardRef(({ ...props }, ref) => {
  const {
    saveJob,
    saveJobIsLoading,
    savedJobsListing,
    refetchSavedJobsListing,
    savedJobsListingisFetching,
    appliedJobsListing,
    refetchAppliedJobsListing,
    removeSavedJob,
    removeSavedJobIsLoading,
    applyDisc,
    setAppliedJob,
  } = useContext(JobsListingContext);

  const { push } = useRouter();
  const { t } = useTranslator();

  const [selected, setSelected] = useState();

  // useEffect(() => {
  //   refetchSavedJobsListing?.();
  //   refetchAppliedJobsListing?.();
  // }, []);

  if (savedJobsListingisFetching)
    return (
      <HStack justifyContent="center" py={12}>
        <Spinner />
      </HStack>
    );
  return (
    <Stack>
      {savedJobsListing?.length > 0 ? (
        <Stack w="100%">
                  
          <HStack alignItems="stretch" spacing={0} flexWrap="wrap" gap={5} marginBottom="100px" >
            {savedJobsListing?.map((job, jobIndex) => {
              const isApplied = appliedJobsListing?.find?.(
                (aj) => aj?.job_details?.id === job?.job_details?.id
              );
              return (
                <Card
                h={!isMobile?"290px":"auto"}
                  w={['100%', '100%', '48.2%']}
                  jobIndex={jobIndex}
                  p={4}
                  key={jobIndex}
                  border="1px solid #D9D9D9"
                  borderRadius="20px"
                  //boxShadow="none"
                  boxShadow="md"
                >
                  <SavedJobCard
                    href={'/jobs/' + job?.job_details?.id}
                    onSaveClick={(e) => {
                      setSelected(job);
                      removeSavedJob(job);
                    }}
                    onViewDetailsClick={(e) =>
                      push('/jobs/' + job?.job_details?.id)
                    }
                    job={job}
                    saveLoading={
                      selected?.id === job?.id && removeSavedJobIsLoading
                    }
                    isSaved={true}
                    isApplied={isApplied}
                    onApplyClick={(e) => {
                      if (
                        typeof window !== 'undefined' &&
                        job?.job_details?.how_to_apply === 'EXTERNAL'
                      ) {
                        window.open(
                          job?.job_details?.how_to_apply_text,
                          '_blank'
                        );
                      } else {
                        setAppliedJob?.(job?.job_details);
                        applyDisc?.onOpen?.();
                      }
                    }}
                  />
                </Card>
              );
            })}
          </HStack>
        </Stack>
      ) : (
        <Stack alignItems="center" justifyContent="center" py="12">
          <SavedJobsNotFoundIll />
          <Text>{t('jobs.noSavedJobs') || "You do not have any saved jobs."}</Text>
        </Stack>
      )}
    </Stack>
  );
});
